export default __webpack_public_path__ + "static/media/a9.bf184b9a.png";